module.exports = __webpack_public_path__ + "static/media/icon-supplydrop-orange-light.e06f221c.svg";